import * as React from "react";
import Layout from "../components/shared/Layout";
import SectionOne from "../components/home/SectionOne";
import Property from "../components/home/Property";
import Popular from "../components/home/Popular";
import Discover from "../components/home/Discover";
import CTA from "../components/home/CTA";
import "../assets/styles/home.css";
import Stats from "../components/home/Stats";

export default function HomePage( props ) {
  return (
    <>
      <Layout>
        <SectionOne location={props.location} />
        <Stats/>
        <Property />
        <Popular />
        <CTA />
        <Discover />
      </Layout>
    </>
  );
}

export const Head = () => (
  <>
    <title>Owners Accommodation</title>
    <meta name="description" content="Owners Accommodation: Unlock your ideal timeshare getaways." />
    <meta name="author"content="Owners Accommodation" />
    <meta name="siteUrl"content="https://ownersaccommodation.com/" />
    <meta name="phone"content="(800) 836-0272" />
    <meta name="contact"content="support@ownersaccommodation.com" />
    <meta name="address"content="585 E State Rd 434 # 200, Longwood, FL 32750" />
  </>
)